import React from "react";

import ConfirmDialog from "../../../shared/confirm-dialog";
import { useTrainingMigrationContext } from "./context/training-migration-provider";
import { StartTrainingMigrationForm } from "./start-training-migration-form";

export const StartTrainingMigrationDialog: React.FC = () => {
  const {
    dataMigrationDialogOpen,
    setDataMigrationDialogOpen,
    resetDataMigrationFormState,
    handleStartDataMigration,
  } = useTrainingMigrationContext();

  return (
    <ConfirmDialog
      title="Start Training Data Migration"
      open={dataMigrationDialogOpen}
      setOpen={setDataMigrationDialogOpen}
      onConfirm={async () => {
        handleStartDataMigration();
      }}
      width="md"
      cancelBtnLabel="Cancel"
      confirmBtnLabel="Start"
      onCancel={() => {
        resetDataMigrationFormState();
        setDataMigrationDialogOpen(false);
      }}
    >
      <StartTrainingMigrationForm />
    </ConfirmDialog>
  );
};
